/**
 * Days that should materialize instances for `reId`.
 * Prefer date-cache buckets (not App selectedDates — often empty under mobile-shell).
 * @param {Record<string, string[]>} cache repeatingEventDateCache
 * @param {string} reId
 * @param {string[]} [extraDays] e.g. the todo's own listId (may be before cache range start)
 * @returns {string[]}
 */
function daysToMaterialize(cache, reId, extraDays = []) {
  const days = new Set();
  if (reId && cache && typeof cache === "object") {
    for (const day of Object.keys(cache)) {
      const bucket = cache[day];
      if (Array.isArray(bucket) && bucket.includes(reId)) days.add(day);
    }
  }
  for (const day of extraDays) {
    if (day) days.add(String(day));
  }
  return [...days].sort();
}

module.exports = { daysToMaterialize };
